<template>
  <Teleport to="body">
    <Transition name="modal-fade">
      <div
        v-if="modelValue"
        class="fixed inset-0 z-9999 flex items-center justify-center p-4"
        @click.self="close"
      >
        <!-- 遮罩 -->
        <div
          class="absolute inset-0 bg-black/70"
          @click="close"
        />

        <!-- 弹窗主体 -->
        <div
          class="relative z-10 w-full max-w-5xl h-[82vh] rounded-2xl overflow-hidden shadow-2xl border border-white/10 flex flex-col"
          @click.stop
        >
          <!-- 关闭按钮 -->
          <button
            class="absolute top-4 right-4 z-20 flex items-center justify-center w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors"
            @click="close"
          >
            <UIcon name="i-lucide-x" class="size-4" />
          </button>

          <!-- 内容：EffectPickerPanel 填满弹窗 -->
          <EffectPickerPanel
            v-if="modelValue"
            :initial-effect-type="initialEffectType"
            :is-dev="isDev"
            class="flex-1 min-h-0"
            @select="onSelect"
          />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import EffectPickerPanel from "@/components/ai-effects/EffectPickerPanel.vue";

const store = useStore();
const isDev = computed(() => store.state.user.is_dev);

const props = defineProps({
  /** v-model:open 控制弹窗显示 */
  modelValue: {
    type: Boolean,
    default: false,
  },
  /** 初始选中的 effect 类型 */
  initialEffectType: {
    type: String,
    default: "video",
  },
});

const emit = defineEmits(["update:modelValue", "select"]);

const router = useRouter();

const close = () => {
  emit("update:modelValue", false);
};

const onSelect = (effect) => {
  // 先关闭弹窗
  close();
  // 导航到对应 effect 页面
  router.push(`/ai/effects/${effect.effect_type}/${effect.code}/`);
  // 同时向父组件暴露选中的 effect
  emit("select", effect);
};
</script>

<style scoped>
/* 弹窗淡入淡出动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-active .relative,
.modal-fade-leave-active .relative {
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
.modal-fade-enter-from .relative {
  transform: scale(0.96) translateY(8px);
  opacity: 0;
}
.modal-fade-leave-to .relative {
  transform: scale(0.96) translateY(8px);
  opacity: 0;
}
</style>
